'use client';

import { useState, type ReactNode } from 'react';

import { BETA_PILLE, stilVorlage } from './stil';

interface Eigenschaften {
  stil: string;
  titel: string | null;
  nachricht: string;
  mehr: string;
  weniger: string;
  /** Was hinter „Mehr“ steht (Knopf zum Ziel, Schliessen) — ausserhalb des gekürzten Textes. */
  children?: ReactNode;
}

/**
 * Eine Zeile der Hinweisleiste — dieselbe in der App (`BannerStrip`) und auf
 * der serverseitigen 404 (`fehlerseite/HinweisLeisteFehlerseite`). Das
 * Telefon-Verhalten (eine Zeile, „Mehr“) steckt in `ZEILE_CSS`, das die Leiste
 * einmal einbindet.
 */
export default function HinweisZeile({ stil, titel, nachricht, mehr, weniger, children }: Eigenschaften) {
  const [offen, setOffen] = useState(false);
  const vorlage = stilVorlage(stil);
  return (
    <div style={{
      background: vorlage.bg,
      borderBottom: `2px solid ${vorlage.border}`,
      color: vorlage.text,
      padding: '8px 16px',
      fontSize: '1rem',
      lineHeight: 1.5,
    }}>
      <div className={`bs-zeile${offen ? ' bs-zeile-offen' : ''}`} style={{
        maxWidth: 1280,
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        flexWrap: 'wrap',
      }}>
        {stil === 'beta' && <span style={BETA_PILLE}>BETA</span>}
        <div className="bs-text" style={{ flex: '1 1 160px', minWidth: 0 }}>
          {titel && <strong style={{ marginRight: 6 }}>{titel}</strong>}
          {nachricht}
        </div>
        <button
          type="button"
          className="bs-mehr"
          onClick={() => setOffen((v) => !v)}
          aria-expanded={offen}
          style={{
            background: 'none',
            border: 'none',
            color: vorlage.accent,
            cursor: 'pointer',
            padding: 0,
            font: 'inherit',
            fontWeight: 600,
            whiteSpace: 'nowrap',
          }}
        >
          {offen ? weniger : mehr}
        </button>
        {children}
      </div>
    </div>
  );
}
